import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Action from '@components/Action'
import Edit from '@components/Icon/Edit'
import Delete from '@components/Icon/Delete'
import ArrowBackIcon from '@components/Icon/ArrowBack'
import { showDialog, isCancellationError } from '@components/Dialog'

class Actions extends Component {
  static propTypes = {
    matchUrl: PropTypes.string,
    invoicingEntityId: PropTypes.string,
    invoicingEntityStore: PropTypes.object,
    invoicingEntity: PropTypes.object,
    modalStore: PropTypes.object,
    history: PropTypes.object,
    growlStore: PropTypes.object
  }

  generateBackLink = () => {
    return this.props.matchUrl.substr(
      0,
      this.props.matchUrl.lastIndexOf(`/${this.props.invoicingEntityId}`)
    )
  }

  deleteInvoiceEntity = (invoiceId, legalName) => {
    const { invoicingEntityStore, history, growlStore } = this.props
    return showDialog({
      title: 'Delete this invoicing entity?',
      text: legalName,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    })
      .then(() => {
        return invoicingEntityStore
          .deleteInvoicingEntity(invoiceId)
          .then(() => {
            history.push(this.generateBackLink())
          })
      })
      .catch(err => {
        if (isCancellationError(err)) return
        growlStore.showError(
          err,
          `Couldn't delete invoicing entity ${legalName}`
        )
      })
  }

  render () {
    const backLink = this.generateBackLink()
    const {
      invoicingEntityId,
      invoicingEntity,
      invoicingEntityStore,
      modalStore
    } = this.props
    return (
      <div className='actions-wrapper clearfix'>
        <ul className='actions right-list'>
          <li
            className='action'
            data-cy='edit-invoicing-entity-btn'
            onClick={() => {
              return modalStore.show({
                type: 'INVOICING_ENTITY_FORM',
                props: {
                  invoicingEntity,
                  parentAccount: invoicingEntity.parentAccount,
                  onSaveSuccess: savedInvoicingEntity => {
                    invoicingEntityStore.getInvoicingEntity(
                      savedInvoicingEntity.id
                    )

                    modalStore.close()
                  }
                }
              })
            }}
          >
            <Action>
              <Edit />
              <span>Edit</span>
            </Action>
          </li>
          <li className='action'>
            <Action
              onClick={() =>
                this.deleteInvoiceEntity(
                  invoicingEntityId,
                  invoicingEntity.legalName
                )
              }
            >
              <Delete />
              <span>Delete</span>
            </Action>
          </li>
        </ul>
        <ul className='actions left-list'>
          <Link to={backLink}>
            <Action>
              <li>
                <ArrowBackIcon />
                <span>Invoicing entities list</span>
              </li>
            </Action>
          </Link>
        </ul>
      </div>
    )
  }
}

export default withRouter(inject('modalStore', 'growlStore')(observer(Actions)))
